import axios from "axios";
import api from "../api";
import { auth, baseURL, buses} from "../api_endpoints";
import { param, th } from "motion/react-client";





export const sendOtp = async (data) => {
  let result = [];
  try {
    const response = await api.post(`${baseURL}/api/auth/send-otp`,{phone:data});
    console.log("ProductLevel : ", response);
    result = response;
    return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
  
};

export const VERIFYOtp = async (data) => {
  let result = [];
  try {
    const response = await api.post(auth.VERIFY_OTP,{phone:data.number,otp:data.otp});
    console.log("ProductLevel : ", response);
    result = response;
    return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
  
};

export const getProfile = async (token) => {
  let result = [];
  try {
    const response = await api.get(auth.GET_PTOFILE,{
          headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json",
        },
    });
    console.log("ProductLevel : ", response);
    result = response;
    return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
  
};

export const termConcition = async (token) => {
  let result = [];
  try {
    const response = await api.get(auth.termAndConditions,{
          headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json",
        },
    });
    console.log("ProductLevel : ", response);
    result = response;
    return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
  
};
export const editProfile = async ({data,token}) => {
  let result = [];
  console.log("token",token,data);
  
  try {
    const response = await api.put(auth.EDIT_PROFILE,
      {
        name:data.name,
        email:data.email,
        phone:data.phone,
    },
      {
          headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json",
        },
    },
);
    console.log("ProductLevel : ", response);
    result = response;
     return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
 
};

export const logoutUser = async ({phone,token}) => {
  let result = [];
  console.log("token",token);
  
  try {
    const response = await api.post(auth.LOGOUT_USER,
      {

        phone:phone,
    },
      {
          headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json",
        },
    },
);
    console.log("ProductLevel : ", response);
    result = response;
     return result;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
    return error
  }
 
};

export const searchBuses = async (data) =>{
  console.log(data);
  
  try {

   const result= await api.get(`${buses.SEARCH_BUSES}`,
   
       {params:{
            date:data.date,  
          from:data.from,
      to:data.to,

        },
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
        
    },
    
    )

    return result;
    
  } catch (error) {
    throw error;
  }
}

export const getBusDetails =async(data)=>{
  console.log('data.params',data.params);
  
  try {
    const result= await api.get(`${buses.BUS_DETAILS}${data.id}?date=${data.params.date}&from=${data.params.from}&to=${data.params.to}&timeSlot=${data.params.timeSlot}`,{
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
       
    },)
    return result;
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const bookBus = async(data)=>{
  console.log(data);
  

  let input=data.objectiveData;
  try {
    const result= await api.post(buses.BOOK_BUS,input,{
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
    },)
    return result
    
    
  } catch (error) {
    throw error;
  }
}

export const bookigHistory =async(data)=>{
  try {
    const response=await api.get(auth.BOOKING_HISTORY,{
          headers: {
          Authorization: `Bearer ${data}`,   
          "Content-Type": "application/json",
        },
    })

    return response
    
  } catch (error) {
    throw error
  }
}

export const bookingDetails = async (data)=>{
  try {
    const response=await api.get(buses.BOOK_DETAILS+data.id,{
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
    })
    return response
    
  } catch (error) {
    throw error
  }
}


export const getCoupon =async(token)=>{
  try {
    const result= await api.get(buses.GET_COUPON,{
          headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json",
        },
    },)
    return result;
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const applyCoupon =async(data)=>{
  try {
    const result= await api.post(buses.APPLY_COUPON,{
      bookingId:data.bookingId,
      couponCode:data.couponCode
    },{
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
    },)
    return result;
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const searchCities =async(data)=>{
  try {
    const result= await api.get(`${buses.SEARCH_CITIES}?q=${data.query}&type=${data.from}`,{
          headers: {
          Authorization: `Bearer ${data.token}`,   
          "Content-Type": "application/json",
        },
    },)
    return result;
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}